import { type LanguageCode, languageMap } from '@repo/i18n/i18n-resources/languages';
import { createLocalizedPath } from '@repo/i18n/i18n-utils';

export function getLocalizedCurrentPath(newLanguage: LanguageCode, currentLanguage: string): string | undefined {
    if (newLanguage === currentLanguage || typeof window === 'undefined') return undefined;

    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split('/');
    const basePathSegments =
        pathSegments[1] && pathSegments[1] in languageMap ? pathSegments.slice(2) : pathSegments.slice(1);
    const localizedPath = createLocalizedPath(newLanguage, `/${basePathSegments.join('/')}`, true);

    return `${localizedPath}${url.search}${url.hash}`;
}
